import React from 'react'
import ServicesContent from'./services-content'
 function Services(){
	return(
		  <>
		  <ServicesContent title="Services"/>
		  </>
 )
	}
 export default Services